// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ey-f","col":"styles_col__O8Nuh"};